const updateSearchResults = (pageNumber, sort, financeType, afterUpdate) => {
    const currentPage = "special-offers";

    // fetch the updated search results
    $.get(`/${currentPage}/search-results-partial/?pageNumber=${pageNumber}&sort=${sort}&financeType=${financeType}`, function (data) {
        // Update the search results container with the HTML returned from the server
        const searchResultsContainer = document.getElementById("search-results-container");
        searchResultsContainer.innerHTML = data;

        if (window.initializeSpecialOfferImageCarousels) {
            window.initializeSpecialOfferImageCarousels(searchResultsContainer);
        }

        // callback
        afterUpdate();

        // rebind the pagination links now they've been replaced
        bindPaginationLinkEvents();
    });
}

const getCurrentFinanceType = () => {
    return document.querySelector("#personal-button").classList.contains("active") ? "Personal" : "Business";
}

// function to handle finance type changes
const handleFinanceTypeChange = (financeType) => {
    const selectSort = document.querySelector("#select-sort");
    const sortParam = selectSort ? selectSort[selectSort.selectedIndex].value : "";
    const pageNumber = 1;

    updateSearchResults(pageNumber, sortParam, financeType, () => {
        // update the active state of the buttons
        if (financeType === "Personal") {
            document.getElementById("personal-button").classList.add("active");
            document.getElementById("business-button").classList.remove("active");
        } else {
            document.getElementById("business-button").classList.add("active");
            document.getElementById("personal-button").classList.remove("active");
        }

        // update the URL
        const urlPath = pageNumber > 1 ? `/special-offers/page${pageNumber}/?sort=${sortParam}&financeType=${financeType}` : `/special-offers/?sort=${sortParam}&financeType=${financeType}`;
        window.history.pushState({ sort: sortParam, pageNumber, financeType }, "", urlPath);
    });
};

// use delegated event handling for buttons
document.addEventListener("DOMContentLoaded", function () {
    var searchResultsContainer = document.getElementById("search-results-container");

    if (searchResultsContainer) {
        searchResultsContainer.addEventListener("click", function (event) {
            if (event.target && event.target.matches("#personal-button")) {
                event.preventDefault();
                handleFinanceTypeChange("Personal");
            } else if (event.target && event.target.matches("#business-button")) {
                event.preventDefault();
                handleFinanceTypeChange("Business");
            }
        });
    }
});

// initialize dropdown change event listener
const sortDropdown = document.querySelector("#select-sort");
if (sortDropdown) {
    sortDropdown.onchange = function (event) {
        const selectSort = event.currentTarget;
        const sortParam = selectSort[selectSort.selectedIndex].value;
        const pageNumber = 1;
        const financeType = getCurrentFinanceType();

        updateSearchResults(pageNumber, sortParam, financeType, () => {
            const urlPath = pageNumber > 1 ? `/special-offers/page${pageNumber}/?sort=${sortParam}&financeType=${financeType}` : `/special-offers/?sort=${sortParam}&financeType=${financeType}`;
            window.history.pushState({ sort: sortParam, pageNumber, financeType }, "", urlPath);
        });
    }
}

const bindPaginationLinkEvents = () => {
    document.querySelectorAll(".pagination a").forEach((paginationLink) => {
        paginationLink.addEventListener("click", (event) => {
            event.preventDefault();
            const selectSort = document.querySelector("#select-sort");
            const sort = selectSort[selectSort.selectedIndex].value;
            const pageNumber = event.target.getAttribute("destination-page-number");
            const financeType = getCurrentFinanceType(); // Get the current finance type

            updateSearchResults(pageNumber, sort, financeType, () => {
                // update the URL with current state including finance type and page number
                const urlPath = pageNumber > 1 ? `/special-offers/page${pageNumber}/?sort=${sort}&financeType=${financeType}` : `/special-offers/?sort=${sort}&financeType=${financeType}`;
                window.history.pushState({ sort, pageNumber, financeType }, "", urlPath);

                document.querySelector(".deal-panel").scrollIntoView();
            });
        });
    });
};

window.addEventListener("popstate", (event) => {
    if (event.state) {
        updateSearchResults(event.state.pageNumber, event.state.sort, event.state.financeType, () => {
            const selectSort = document.querySelector("#select-sort");
            if (selectSort) {
                selectSort.value = event.state.sort;
            }
            document.querySelector(".deal-panel").scrollIntoView();
        });
    }
});

// setup initial state
const selectSort = document.querySelector("#select-sort");
if (selectSort) {
    const initialSort = selectSort[selectSort.selectedIndex].value;
    window.history.replaceState({ sort: initialSort, pageNumber: 1, financeType: "Personal" }, "");
}
